var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lk-input', { 'lk-input--error': _vm.error }, { 'lk-input--valid': _vm.valid }]},[_c('input',_vm._b({staticClass:"lk-input__input",attrs:{"name":_vm.name},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.emitChange($event.target.value)},"blur":_vm.handleBlur,"focus":_vm.handleFocus,"click":_vm.handleClick}},'input',_vm.$attrs,false)),_vm._v(" "),_vm._t("action")],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/lk/lk-input/index.vue?vue&type=template&id=2d6ce57f&
// module id = 1339
// module chunks = 0